<template>
  <v-card>
    <v-card-title class="headline py-2">
      Настройки колонок
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    
    <v-card-text>
      <output-settings v-if="output" v-model="all_settings" :objects="objects"></output-settings>
      <input-settings v-else v-model="all_settings" :objects="objects"></input-settings>
    </v-card-text>
  
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn color="success" @click="submit" :disabled="status.btnDisabled">Сохранить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
      <v-spacer></v-spacer>
      <v-btn v-if="!is_default" @click="resetSettings" color="warning">Удалить личные настройки</v-btn>
    </v-card-actions>

  </v-card>
</template>

<script>
  import InputSettings from '../../Common/InputSettings'
  import OutputSettings from '../../Common/OutputSettings'
  
  export default {
    name : "",
  
    components: {
      InputSettings,
      OutputSettings
    },
    
    props:{
      label_id: {
        type: String,
        required: true,
      },
      settings: {
        type: Array,
        required: true,
      },
      objects: {
        type: Array,
        required: true,
      },
      output:{
        type: Boolean,
        required: false,
        default: false
      },
      is_default:{
        type: Boolean,
        required: false,
        default: true
      }
    },
    
    computed:{
      all_settings:{
        get(){ return this.settings},
        set(v){}
      }
    },
    
    data(){
      return {
        status:{
          btnDisabled: false,
          text: '',
          className:'success--text darken-1'
        },
      }
    },
    
    methods: {
      submit(){
        this.status={ btnDisabled: true, text: 'Сохранение', className:'secondary--text lighten-1' }
        
        let type = (this.output) ? 1 : 0
        this.$store.dispatch('analytics_old/indicators/saveSettings', {id: this.label_id, type, data: this.all_settings}).then( response =>{
          this.status={ btnDisabled: false, text: 'Сохранено', className:'success--text darken-1' }
          this.$emit('save', {type: 'settings', data: {label_id: this.label_id, output: this.output } })
        }).catch( error => {
          this.status = { btnDisabled: false, text: 'Ошибка', className:'error--text darken-1' }
        })
      },
  
      resetSettings(){
        this.$dmsAgree('Вы уверены, что хотите удалить личные настройки? \n После удаления личных настроек к статистике будут применены общие настройки.').then( _ => {
          let type = (this.output) ? 1 : 0
          this.$store.dispatch('analytics_old/indicators/resetSettings', {id: this.label_id, type}).then(response =>{
            this.$emit('save', {type: 'resetSettings', data: {label_id: this.label_id, output: this.output } })
          })
        })
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics_old/components/Statistics/Forms/SettingsForm.vue